// extracted by mini-css-extract-plugin
export default {"selector":"SignalSelector_selector__ov86c"};